module.exports = __webpack_public_path__ + "img/dp.4d8877e9.png";